/* istanbul ignore file */
import React from 'react';

export default function FDICLogo() {
  return (
    <svg
      fill="none"
      height="16"
      viewBox="0 0 41 16"
      width="41"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M9.42563 0.28983H14.9202C19.8739 0.28983 23.0337 3.33596 23.0337 8.09056C23.0337 13.3574 19.5323 15.9194 13.9523 15.9194H9.42563V0.28983ZM14.5799 3.8748C14.3805 3.8748 14.1244 3.90294 13.7828 3.90294V12.33C16.5726 12.33 18.7363 11.2196 18.7363 8.00268C18.7363 5.24123 16.9711 3.8748 14.5799 3.8748ZM40.0588 4.84011V0.711793C38.9484 0.256313 37.9517 0 36.5569 0C31.9734 0 28.3007 3.47324 28.3007 8.05683C28.3007 12.6404 31.9162 16 36.4716 16C38.0944 16 39.2043 15.658 40.0585 15.0033V10.8754C38.7774 11.6723 37.895 12.0139 36.699 12.0139C34.3932 12.0139 32.5996 10.3347 32.5996 7.85745C32.5996 5.43739 34.4216 3.67241 36.699 3.67241C37.9517 3.67262 38.8627 4.09974 40.0588 4.84011ZM0 0.28983V15.9194H4.29869L4.32727 9.94105H8.51231V6.32558H4.35584L4.32727 3.90552H8.82534V0.28983H0ZM23.4894 15.9194H27.7885V0.28983H23.4894V15.9194Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
}
